var AppDispatcher = require('../core/AppDispatcher.jsx');
var Constants = require('../constants/ApplicationConstants.js');
var ActionTypes = Constants.ActionTypes;

module.exports = {
    applicationRetrieveSucceeded: function (application) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.APPLICATION_RETRIEVE_SUCCESS,
            applicationData: application
        });
    },
    applicationRetrieveFailed: function (applicationId) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.APPLICATION_RETRIEVE_ERROR,
            applicationId
        });
    },
    applicationSaveSucceeded: function (applicationId, wipId) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.APPLICATION_SAVE_SUCCESS,
            applicationId,
            wipId
        });
    },
    applicationSaveFailed: function (applicationId) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.APPLICATION_SAVE_ERROR,
            applicationId
        });
    },
    applicationSubmitSucceeded: function (data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.APPLICATION_SUBMIT_SUCCESS,
            data
        });
    },

    sendInvestmentOptions: function (investmentOptionList) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_INVESTMENT_OPTIONS,
            investmentOptionList: investmentOptionList
        });
    },
    setAdviserFeeTypeOptions: function (data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_ADVISER_FEE_TYPE_OPTIONS,
            data: data
        });
    },
    sendBankAccountDetails: function (data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_BANK_ACCOUNT_DETAILS,
            data: data
        });
    },
    sendClientAccountDetails: function (data, forRetrieve) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SEND_CLIENT_ACCOUNT_DETAILS,
            data: data,
            forRetrieve: forRetrieve
        });
    },
    applicationSubmitFailed: function () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.APPLICATION_SUBMIT_FAILED
        });
    },
    downloadFormsSuccess: function (data) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.DOWNLOAD_FORMS_SUCCESS,
            data: data
        });
    },
    downloadFormsFailed:function() {
        AppDispatcher.dispatch({
            actionType: ActionTypes.DOWNLOAD_FORMS_FAILED
        });
    },
    killSwitchRetrieveSuccess: function (killSwitch) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.DIGITALCONSENT_KILLSWITCH_SUCCESS,
            killSwitch: killSwitch
        });
    },
    killSwitchRetrieveFailed: function (killSwitchName) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.DIGITALCONSENT_KILLSWITCH_ERROR,
            killSwitchName: killSwitchName
        });
    },
    asfFormKillSwitchRetrieveSuccess: function (killSwitch) {
        
        AppDispatcher.dispatch({
            actionType: ActionTypes.ASF_FEE_KILLSWITCH_SUCCESS,
            killSwitch: killSwitch
        });
    },
    asfFormKillSwitchRetrieveFailed: function (killSwitch) {
        
        AppDispatcher.dispatch({
            actionType: ActionTypes.ASF_FEE_KILLSWITCH_ERROR,
            killSwitch: killSwitch
        });
    },
    asfCongratulationsPageKillSwitchRetrieveSuccess: function (killSwitch) {
        
        AppDispatcher.dispatch({
            actionType: ActionTypes.ASF_CONGRATULATIONS_PAGE_KILLSWITCH_SUCCESS,
            killSwitch: killSwitch
        });
    },
    asfCongratulationsPageKillSwitchRetrieveFailed: function (killSwitch) {
        
        AppDispatcher.dispatch({
            actionType: ActionTypes.ASF_CONGRATULATIONS_PAGE_KILLSWITCH_ERROR,
            killSwitch: killSwitch
        });
    },
    CongratulationsPageDocumentKillSwitchRetrieveSuccess: function (killSwitch) {
        
        AppDispatcher.dispatch({
            actionType: ActionTypes.CONGRATULATIONS_PAGE_DOCUMENT_KILLSWITCH_SUCCESS,
            killSwitch: killSwitch
        });
    },
    CongratulationsPageDocumentKillSwitchRetrieveFailed: function (killSwitch) {
        
        AppDispatcher.dispatch({
            actionType: ActionTypes.CONGRATULATIONS_PAGE_DOCUMENT_KILLSWITCH_ERROR,
            killSwitch: killSwitch
        });
    },
    onContinueSession: function (extend) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.EXTEND_SESSION,
            extend: extend
        });
    },
    setClientIdentificationMode: (data) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.CLIENT_IDENTIFICATION_MODE_LOADED_IN_APPLICATION_FORM,
            data: data
        });
    },
    setCommSeeBackFile: (data) => {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SET_COMMSEE_BACKFILE,
            data: data
        });
    },
    downsizerContributionKillSwitchRetrieveSuccess: function (killSwitch) {

        AppDispatcher.dispatch({
            actionType: ActionTypes.DOWNSIZER_CONTRIBUTION_KILLSWITCH_SUCCESS,
            killSwitch: killSwitch
        });
    },
    downsizerContributionKillSwitchRetrieveFailed: function (killSwitch) {

        AppDispatcher.dispatch({
            actionType: ActionTypes.DOWNSIZER_CONTRIBUTION_KILLSWITCH_ERROR,
            killSwitch: killSwitch
        });
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./actions/ApplicationApiCallBackActions.js